import React, { Component } from "react";
import { ListItem, ListItemText } from "@mui/material";

class TierDetailsEmailListItem extends Component {
  render() {
    return (
      <ListItem>
        <ListItemText primary={this.props.data.email} />
      </ListItem>
    );
  }
}

export default TierDetailsEmailListItem;
